import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import {
  type CreateLotSizingLine,
  type CreateLotSizingLineInput,
  lotSizingAddLineSchema,
} from '@/features/lot-sizing/schema/lot-sizing-add-line-schema';

export function useLotSizingAddLineForm(lotSizingId: string) {
  const form = useForm<CreateLotSizingLineInput, unknown, CreateLotSizingLine>({
    mode: 'onChange',
    defaultValues: {
      lotSizingId,
      productId: '',
    },
    resolver: zodResolver(lotSizingAddLineSchema),
  });

  return form;
}
